import { gql } from '@apollo/client'

export const UNREAD_CASE_EMAILS_COUNT_QUERY = gql`
  query unreadCaseEmailsCount($caseId: ID) {
    unreadCaseEmailsCount(caseId: $caseId)
  }
`
